import React from "react";
import theme from "../../theme";

const IconComponent = ({
  name,
  width = 24,
  height = 25,
  fill = theme.palette.primary.c02,
  ...props
}) => {
  const icons = {
    SandTimer: (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.3373 7.86166V4.5437C18.3368 4.1488 18.1797 3.7702 17.9005 3.49096C17.6213 3.21172 17.2427 3.05465 16.8478 3.0542L6.42126 3.0542C6.02636 3.05465 5.64776 3.21172 5.36853 3.49096C5.08929 3.7702 4.93221 4.1488 4.93176 4.5437V7.89507C4.93231 8.12621 4.98638 8.35408 5.08975 8.56082C5.19312 8.76755 5.34297 8.94754 5.52755 9.08665L10.3933 12.7359L5.5276 16.3852C5.343 16.5243 5.19314 16.7043 5.08976 16.9111C4.98639 17.1178 4.93231 17.3457 4.93176 17.5768V20.9282C4.93221 21.3231 5.08929 21.7017 5.36853 21.9809C5.64776 22.2602 6.02636 22.4172 6.42126 22.4177H16.8478C17.2427 22.4172 17.6213 22.2602 17.9005 21.9809C18.1797 21.7017 18.3368 21.3231 18.3373 20.9282V17.6102C18.3367 17.38 18.283 17.1531 18.1804 16.947C18.0779 16.7409 17.9292 16.5613 17.7459 16.422L12.8695 12.7359L17.746 9.04993C17.9292 8.91063 18.0779 8.73096 18.1805 8.52488C18.283 8.3188 18.3367 8.09185 18.3373 7.86166ZM16.8478 4.5437V6.77754H6.42126V4.5437L16.8478 4.5437ZM16.8478 20.9282H6.42126V17.5768L11.6328 13.6682L16.8478 17.6102V20.9282Z"
          fill={fill}
          style={{ fill: fill, fillOpacity: 1 }}
        />
      </svg>
    ),
  };

  return icons[name] || null;
};

export default IconComponent;
